<div data-cy="iq-generate-audio-notes-modal__page" mat-dialog-title class="border-b-g">
    <div class="flex align-center gap-20 pull-left pl-20 sans-regular">
        <span class="iq-badge">
            <img src="../../../../../../assets/png/iq_analysis_white.png" alt="IQ">
        </span>
        <span [style.color]="'#2800d2'">{{ 'iq.meeting_notes_audio' | transloco }}</span>
    </div>
    <button data-cy="iq-generate-audio-notes-modal__pr-8-btn" type="button" class="close pull-right pr-8" (click)="close()">
        <span aria-hidden="true">
            <i class="d-text-middle uil uil-multiply unicon-icon"></i>
        </span>
        <span class="sr-only">
            Close
        </span>
    </button>
</div>

<div mat-dialog-content class="dialog-body">
    <div class="px-30 py-30" *ngIf="!showGenerateProcess && !summaryGenerated">
        <div class="flex gap-15">
            <span class="star-badge animate-element"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
            <span class="sans-regular fc-black text-align-start">
                {{ 'iq.meeting_notes_instruction_1' | transloco }} <br>
                {{ 'iq.meeting_notes_instruction_2' | transloco }}
            </span>
        </div>

        <div class="upload-container mt-30" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
            <div class="upload-box" [class.dragging]="isDragging" (click)="!selectedFile && fileInput.click()">
                <span class="bg-plus-circle d-cursor-hand mb-10" *ngIf="!selectedFile">
                    <i class="uil uil-plus-circle clr-white"></i>
                </span>
                <span class="flex align-center gap-15 rounded-16 ts-14 mb-10 px-16 py-4 file-name-wrap" *ngIf="selectedFile">
                    <span>{{ selectedFile.name | trunc:30 }}</span>
                    <i data-cy="iq-generate-audio-notes-modal__icon-action" class="uil uil-multiply cancel-icon" (click)="$event.stopPropagation(); onFileUnSelect()"></i>
                </span>
                <p *ngIf="!selectedFile">{{ 'iq.meeting_notes_audio_drop' | transloco }}</p>
                <p *ngIf="selectedFile">{{ 'iq.meeting_notes_audio_remove' | transloco }}</p>
                <p *ngIf="fileSizeExceeded" style="color: #d32f2f;">{{ 'iq.file_size_exceeded' | transloco }}</p>
                <input data-cy="iq-generate-audio-notes-modal__file-input-field-input" type="file" accept=".flac,.mp3,.mp4,.mpeg,.mpga,.m4a,.ogg,.wav,.webm" class="file-input-field" #fileInput (change)="onFileSelect($event)"/>
            </div>
        </div>

        <div class="flex gap-15 mt-30">
            <span class="star-badge align-center animate-element"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
            <span class="sans-regular fc-black text-align-start">
                {{ 'iq.meeting_notes_instruction_3' | transloco }}
            </span>
        </div>

        <mat-form-field class="ml-10 mt-10">
            <mat-label>{{ 'iq.meeting_date' | transloco }}</mat-label>
            <input data-cy="iq-generate-audio-notes-modal__meeting-date-input" matInput [matDatepicker]="datePickerStart" (focus)="datePickerStart.open()" (click)="datePickerStart.open()" name="newDecision_startDate" [(ngModel)]="meetingDate" required>
            <mat-datepicker-toggle matSuffix [for]="datePickerStart" class="decision-fix-datepicker"></mat-datepicker-toggle>
            <mat-datepicker #datePickerStart></mat-datepicker>
        </mat-form-field>
    </div>

    <div *ngIf="showGenerateProcess && !summaryGenerated" class="py-30 px-30 mt-20">
        <div class="flex gap-20 align-center justify-center fade-in py-30" [class.bg-bugandy]="item.inProgress" [ngStyle]="{'animation-delay': (1 * 0.3) + 's'}" *ngFor="let item of processes">
            <span class="star-badge animate-element" *ngIf="item.inProgress"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
            <span class="tick-badge" *ngIf="item.finished">
                <svg class="fat-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z" fill="#cccccc" stroke-width="2"></path>
                </svg>
            </span>
            <span class="sans-regular" [ngStyle]="{color: item.inProgress ? '#000000 !important':'#aeaeae'}" >{{item.description + (item.inProgress ? '...':'')}}</span>
        </div>
    </div>

    <div class="py-30 mt-20" *ngIf="summaryGenerated">
        <app-iq-audio-notes-summary [meeting]="meeting" (emitMeeting)="updateMeeting($event)" (showAction)="allowAction($event)"></app-iq-audio-notes-summary>
    </div>
</div>

<div mat-dialog-actions align="end" class="px-24" >
    <button data-cy="iq-generate-audio-notes-modal__sans-regular-btn" mat-flat-button class="sans-regular" *ngIf="!showGenerateProcess && !summaryGenerated" (click)="checkAiCreditsAvailable()" [disabled]="!selectedFile || showGenerateProcess || !meetingDate">
        {{'generate' | transloco | capitaliz}}
    </button>
    <mat-spinner [diameter]="20" *ngIf="!showGenerateProcess && !summaryGenerated && isLoading()"></mat-spinner>

    <button data-cy="iq-generate-audio-notes-modal__sans-regular-btn-2" mat-flat-button class="sans-regular" *ngIf="summaryGenerated && showAction" [disabled]="isProcessing || hasEmptyDeadline()" (click)="generateContactMoment()">
        <span *ngIf="!isProcessing">
            {{'iq.generate_contact_moment' | transloco | capitaliz}}
          </span>
          <span *ngIf="isProcessing">{{ 'text.please_wait' | transloco | capitaliz }}</span>
    </button>
</div>
